import { authService } from 'app/api/service/auth-service';

class AuthService {
    public static logout(): Promise<void> {
        return authService.logout();
    }
}

export { AuthService };
